import { Container } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import Breadcrumb from '@components/breadcrumb';
import NextNav from '@components/next-nav';

import { GET_TRIP_PROFILE } from '@queries/trip-profiles';
import LoadingData from '@components/graphql-loading-data';
import GraphqlError from '@components/graphql-error';
import MapSelected from '@components/map-selected';
import TitleBar from '@components/title-bar';

function SelectedDestination() {
  const { clientId, tripProfileId } = useParams();

  const { loading, error, data } = useQuery(GET_TRIP_PROFILE, {
    errorPolicy: 'all',
    variables: {
      id: tripProfileId || '',
    },
    skip: !tripProfileId,
  });
  if (!tripProfileId) return null;
  if (loading) return <LoadingData />;
  if (error) return <GraphqlError error={error} />;
  return (
    <Container fluid h="100vh">
      <Breadcrumb pageStep={3} pb={15} />
      <TitleBar />

      {data && data.singleTripProfile.destinationLat && data.singleTripProfile.destinationLong && (
        <MapSelected
          latitude={data.singleTripProfile.destinationLat}
          longitude={data.singleTripProfile.destinationLong}
          nutsId={data.singleTripProfile.destinationId || ''}
          destination={data.singleTripProfile.destination || ''}
          country={data.singleTripProfile.country || ''}
        />
      )}
      <NextNav
        pt={20}
        next={`/clients/${clientId}/trip-profiles/${tripProfileId}/vibe-attractions`}
        saveVisible={false}
      />
    </Container>
  );
}

export default SelectedDestination;
